import React from "react";
import { Link } from "react-router-dom";
import Flag from "react-world-flags";

const CareerSection = () => {
  return (
    <div className="flex flex-col md:flex-row justify-between px-8 py-12 bg-white">
      <div className="md:w-2/5 space-y-4 mx-5">
      <div className="bg-blue-700 p-6 border rounded-lg">
        <h2 className="text-2xl md:text-3xl font-bold text-white text-center">
          Unleash your potential with limitless opportunities. Join us in
          shaping a dynamic, innovative community where your success knows no
          bounds. Together, let's achieve greatness.
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 my-2 mt-10">
          <Link
            to="/usa-careers"
            target="_blank"
            className="text-center bg-white text-blue-900 py-3 px-6 rounded-md hover:bg-blue-100"
          >
            <button className="flex"><Flag code="USA" className="w-6 h-6 mr-2"/> USA Careers Page</button>
          </Link>

          <Link
            to="/india-careers"
            target="_blank"
            className="text-center bg-white text-blue-900 py-3 px-6 rounded-md hover:bg-blue-100"
          >
            <button className="flex"><Flag code="IN" className="w-6 h-6 mr-2"/> India Careers Page</button>
          </Link>
        </div>
      </div>
        
      </div>
      <div className="md:w-3/5 mt-8 md:mt-0 text-gray-600 mx-5 text-justify">
        <p>
          At TISSA Technology, we are committed to fostering a culture of
          innovation that is reflected in everything we do. Empower yourself
          with opportunities to achieve new heights and explore exciting
          avenues. Experience a vibrant work environment brimming with fresh
          ideas, diverse perspectives, and a shared drive for excellence.
        </p>
        <p className="mt-4">
          Please note that neither TISSA Technology nor any of its authorized
          recruitment agencies/partners charge candidates any registration fee
          or other fees for attending interviews or securing
          employment/internships. Candidates are advised to verify the
          credentials of any agency or consultant claiming to represent TISSA
          Technology in recruitment processes. Relying on fraudulent employment
          agencies is at the candidate’s own risk, and TISSA Technology
          disclaims any liability for loss or damage arising as a result of such
          actions.
        </p>
        <p className="mt-4">
          TISSA Technology is proud to be an equal opportunity employer. We are
          dedicated to maintaining an inclusive work environment that respects
          and values diversity. We provide equal employment opportunities
          regardless of race, ethnicity, nationality, gender, gender identity,
          gender expression, language, age, sexual orientation, religion,
          marital status, veteran status, socio-economic status, disability, or
          any other characteristic protected by applicable law.
        </p>
      </div>
    </div>
  );
};

export default CareerSection;
